// Implements: F-UIX-018, F-USG-005, F-USG-006
/**
 * `/backoffice/consumption` — "Consumo por ámbito" (UIX.5): the organizations the person
 * administers and the teams they lead, read-only.
 *
 * The page only composes: the targets, the reads and the sections live in the `backoffice`
 * module's `ConsumptionByScope`, which keys each scope's container by its ids (checklist 14).
 * It is keyed here by the person as well, so another person signing in on the same tab never
 * inherits the previous one's choice. Modules never import each other, so the page hands the
 * backoffice the admin module's latency table and "Exportar CSV" (owner 2026-10-19, `REPORT_PARTS`).
 */

import type { ReactElement } from "react";

import { ExportCsvContainer } from "../../modules/admin/containers/ExportCsvContainer";
import { LatencyTable } from "../../modules/admin/components/LatencyTable";
import type { ReportParts } from "../../modules/backoffice/containers/reportParts";
import { ConsumptionByScope } from "../../modules/backoffice/containers/ScopeReportsContainer";
import { useSession } from "../../shared/api/session";
import { useTranslation } from "../../shared/i18n";
import { PageHeader } from "../../shared/ui/molecules/PageHeader";

export const REPORT_PARTS: ReportParts = { LatencyTable, ExportCsv: ExportCsvContainer };

export function ConsumptionPage(): ReactElement | null {
  const { t } = useTranslation();
  const { state } = useSession();
  // `RequireSession` renders this page only for a session; nothing to show otherwise.
  if (state.status !== "authenticated") return null;
  const { user, scopes } = state.view;

  return (
    <section>
      <PageHeader title={t("backoffice.consumption.title")} subtitle={t("backoffice.consumption.intro")} />
      <ConsumptionByScope key={user.id} scopes={scopes} parts={REPORT_PARTS} />
    </section>
  );
}
